module.exports = __webpack_public_path__ + "media/application/images/svgs/save-ad69ace757fde89ea2285c29d8214ce7.svg";